import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Pagination } from '../../components/Pagination';
import { Table } from '../../components/Table';
import { useQueryString } from '../../hooks';
import { MomentFormat, utcToLocalFormat } from '../../plugins/moment';
import { fetcher } from '../../plugins/react-query';
import { Paginated, Seminar } from '../../types';
import { AdminH1 } from '../components/AdminH1';

export const SeminarsList = () => {
  const queryString = useQueryString();
  const { data: seminars } = useQuery<Paginated<Seminar>>(
    `/admin/seminars${queryString}`,
    fetcher,
    { keepPreviousData: true },
  );

  if (!seminars) {
    return <></>;
  }
  return (
    <>
      <div className="flex justify-between">
        <AdminH1>Seminars</AdminH1>
        <Button
          text="Add"
          to={`/admin/seminars/add`}
          className="h-8 font-normal text-indigo-600 hover:text-indigo-900"
        />
      </div>

      <Card>
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Th>Title</Table.Th>
              <Table.Th>Created at</Table.Th>
              <Table.Th>Hide</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {seminars.items.map((seminars) => (
              <Table.Row key={seminars.id}>
                <Table.Td>{seminars.title}</Table.Td>
                <Table.Td>
                  {utcToLocalFormat(seminars.createdAt, MomentFormat.LLL)}
                </Table.Td>
                <Table.Td>{seminars.isHide ? '숨김' : '-'}</Table.Td>
                <Table.Td className="text-right">
                  <Link
                    className="font-normal text-indigo-600 hover:text-indigo-900"
                    to={`/admin/seminars/${seminars.id}`}
                  >
                    Details
                  </Link>
                </Table.Td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <Pagination>
          <Pagination.Label
            count={seminars?.items.length}
            total={seminars.total}
          />
          <Pagination.Nav basePath="/admin/seminars" total={seminars.total} />
        </Pagination>
      </Card>
    </>
  );
};
